/* eslint-disable global-require */
// CATALOG - Product Details

/**
* New / Refactored initMethod's
*/
import { init as initProductDetails } from './product-details/product-details';
import { init as initStockNotification } from './product-details/stock-notification';
import { init as initPrivacyInfos } from './product-details/privacy-infos';
import { init as initModelListUpdate } from './product-details/model-list';
import { init as initSizeSelector } from './product-details/size-selector';
import { init as initConversionUpdates} from './product-details/conversion-zone-updates';
import { init as initProductPicture } from './product-details/product-picture';
import { init as initStoreStock } from './product-details/store_stock.entry';
import { init as initRichContent } from './product-details/rich-content';
import { init as initCncTab } from './product-details/click-n-collect-tabs';
import { init as initMediaZoom, setVideoDataReceived, hasVideos } from './product-details/media-zoom';
import { init as init360 } from './product-details/product-360.entry';
import { init as initInternalNavigation } from './product-details/internal-navigation';
import { init as initProductPage } from './product';
import { init as initSmartSize, smartSizeTriggerSelector } from './product-details/smartsize-guide/smartsize.entry';
import { openPanel as openPanelStoreSelector } from './product-details/pdp-store_selection-finder';


/**
* Exported Init Function
*/
export function init() {

  // Listen for events from C&C1H
  listenForExpressCheckoutInit();
  // Legacy (ES5) product details init
  initProductDetails();

  // Init conversion updates
  if (cube.$('#conversion-zone')) initConversionUpdates();

  // Model List
  if (cube.$('.product-models')) initModelListUpdate();

  // Init stock notifications
  if (cube.$id('back-in-stock-submit')) initStockNotification();

  // Init privacy infos modal
  if (cube.$('.privacy-infos__invite')) initPrivacyInfos();

  // Init size selector
  if (cube.$('.js-product-sizer')) initSizeSelector();

  // Init Product Picture
  if (cube.$('.product-picture')) initProductPicture();

  // Init rich content video (async)
  if (cube.$id('ConceptionHistoryFloor')) initRichContent();

  // Express Checkout
  // If Express Checkout CTA or CNC1H is enabled
  if (cube.$id('express-payment-cta') || cube.$('.js-add-to-cart--cnc1h')) {
    import(/* webpackChunkName: "express-checkout" */ './product-details/express-checkout').then(
      ({ init: initExpressCheckout }) => {
        initExpressCheckout();
        loadPayolutionFraudPrevention();
      }
    );
  }

  // Gift Card
  if (cube.$id('gift-card')) {
    import(/* webpackChunkName: "gift-card" */ './giftcard/giftcard').then(
      ({ init: initGiftCard }) => initGiftCard()
    );
  }

  // Financing (3/4x payment method on PDP)
  if (cube.$id('financing')) {
    import(/* webpackChunkName: "financing" */ './financing/financing').then(
      ({ init: initFinancing }) => initFinancing()
    );
  }

  // Floor QAA
  if (cube.$id('svelteQaa')) {
    import(/* webpackChunkName: "floor-qaa" */ './product-details/floor-qaa/floor-qaa').then(
      ({ init: initQuestionAnswer }) => initQuestionAnswer()
    );
  }


  // Trylive
  if (cube.$id('TryLiveContainer')) {
    import(/* webpackChunkName: "Trylive" */ './product-details/TryLive/TryLive').then(
      ({ init: initTrylive, processTryLive }) => {
        initTrylive();
        cube.event.on('modelChanged', processTryLive);
        cube.event.on('sizeChanged', processTryLive);
      }
    );
  }


  initProductPage();

  // Init Media Zoom
  if (cube.$id('media-zoom')) {
    if (hasVideos() && cube.$id('VideoFloor')) {
      // If Media Zoom has video : wait for 'videoDataReceived' event
      // Once we receive it, we save it in the 'mediaZoom.videoDataReceived'
      // and init the media zoom
      cube.event.on('videoDataReceived', videos => {
        setVideoDataReceived(videos);
        initMediaZoom();
      });
    }
    else initMediaZoom();
  }

  init360();

  if (cube.$('.js-open-store-selector, .buying-zone')) initStoreStock();

  window.addEventListener('open-store-selector', () => {
    openPanelStoreSelector();
  });

  if (cube.$('.buying-zone--cnc1h')) initCncTab();

  if (document.querySelectorAll(smartSizeTriggerSelector).length > 0){
    initSmartSize();
  }

  initInternalNavigation();
}

// Init express for C&C 1H
function listenForExpressCheckoutInit() {
  // Bind 'initExpressCheckout' when receiving the event (triggered from legacy) if express is not already initialized
  if (!cube.$id('express-payment-cta') && !cube.$id('gift-card')) {
    import(/* webpackChunkName: "express-checkout" */ './product-details/express-checkout').then(
      ({ init: initExpressCheckout }) => {
        document.addEventListener('initExpressCheckoutCC', initExpressCheckout);

        // Once ExpressCheckout is closed : remove the eventListener
        document.addEventListener('closeExpress', () => {
          document.removeEventListener('initExpressCheckoutCC', initExpressCheckout);
        });

        loadPayolutionFraudPrevention();
      }
    );
  }
}

function loadPayolutionFraudPrevention(){
  // Payolution Fraud Prevention (DE only)
  if (window.tc_vars.env_country === 'DE') {
    import(/* webpackChunkName: "payolution-fraud-prevention" */ '@/checkout/payolution-fraud-prevention').then(
      ({ init: initPayolutionFraudPrevention }) => initPayolutionFraudPrevention()
    );
  }
}



// WEBPACK FOOTER //
// ./src/catalog/product-details.entry.js